const chartStyle = (withZoom: boolean) => ({
  // Set on the surface rather than per layer so every layer recharts renders inherits it. Not
  // higher up: recharts puts an inline `cursor: default` on `.recharts-wrapper`.
  '& .recharts-surface': {
    userSelect: 'none',
    cursor: withZoom ? 'zoom-in' : undefined,
  },
  // Dragging over the axis labels doesn't zoom.
  '& .recharts-xAxis, & .recharts-yAxis': {
    cursor: 'default',
  },
  // recharts v3 makes the chart surface and other SVG nodes focusable, so clicking draws
  // browser focus rings absent pre-v3 (`accessibilityLayer={false}` covers the surface but not
  // every node). Reset focus outlines on any focused element inside the chart EXCEPT HTML
  // rendered in <foreignObject> (e.g. the Messages retry button), which must keep its focus
  // indicator. `:not(foreignObject *)` needs Selectors L4 (Safari 16.4+, our browser floor).
  '& :focus:not(foreignObject *)': {
    outline: 'none',
  },
});

export default chartStyle;
